(function ($, Drupal, once) {
  Drupal.behaviors.sidebar_first = {
    attach: (context) => {
      once('halifax_sidebar_first', '.layout-sidebar-first', context).forEach(
        (element) => {
          const $sidebar = $(element);
          const $content = $('.layout-content');

          function moveSidebar() {
            if (window.matchMedia('(max-width: 768px)').matches) {
              $sidebar.insertBefore($content);
            } else {
              $sidebar.insertAfter($content);
            }
          }

          let resizeTimer;
          moveSidebar();

          function moveSidebarOnResize() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              if (window.matchMedia('(max-width: 768px)').matches) {
                moveSidebar();
              } else {
                moveSidebar();
              }
            }, 500);
          }

          $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(moveSidebar, 500);
          });

          $(window).on('resize', moveSidebarOnResize);
        }
      );
    },
  };
})(jQuery, Drupal, once);
